var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: _vm.loading ? "container-loading" : "",
      attrs: {
        fluid: !_vm.loading,
        "grid-list-lg": !_vm.loading,
        "fill-height": _vm.loading
      }
    },
    [
      !_vm.loading
        ? _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-slide-y-transition",
                    { attrs: { mode: "out-in" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "hidden-sm-and-down",
                              attrs: { xs12: "", sm3: "" }
                            },
                            [
                              _c(
                                "v-slide-y-transition",
                                { attrs: { mode: "out-in" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-center mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "v-icon-avatar"
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                $mdiAccountCircle\n                                            "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            {
                                              attrs: {
                                                "two-line": "",
                                                subheader: ""
                                              }
                                            },
                                            [
                                              _vm.lead.leadReference
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Reference\n                                                "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.lead
                                                                      .leadReference
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.lead.leadFirstName
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    First name\n                                                "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.lead
                                                                      .leadFirstName
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.lead.leadLastName
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Last name\n                                                "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.lead
                                                                      .leadLastName
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.lead.status_name
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Status\n                                                "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.lead
                                                                      .status_name
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md9: "" } },
                            [
                              _c(
                                "v-slide-y-transition",
                                { attrs: { mode: "out-in" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-tabs",
                                            {
                                              staticClass: "mobile-tabs",
                                              attrs: {
                                                centered: "",
                                                "icons-and-text": "",
                                                "mobile-break-point": "320"
                                              },
                                              on: {
                                                change: _vm.setTabParameter
                                              },
                                              model: {
                                                value: _vm.activeTab,
                                                callback: function($$v) {
                                                  _vm.activeTab = $$v
                                                },
                                                expression: "activeTab"
                                              }
                                            },
                                            [
                                              _c("v-tabs-slider", {
                                                attrs: { color: "secondary" }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab",
                                                {
                                                  class: _vm.isDark
                                                    ? "white--text"
                                                    : "primary--text",
                                                  attrs: { href: "#info" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Information\n                                            "
                                                  ),
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "$mdiInformationOutline"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "info" } },
                                                [
                                                  _vm.activeTab === "info"
                                                    ? _c("item-info", {
                                                        attrs: {
                                                          "item-info": _vm.lead
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab",
                                                {
                                                  class: _vm.isDark
                                                    ? "white--text"
                                                    : "primary--text",
                                                  attrs: { href: "#comments" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Comments\n                                            "
                                                  ),
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "$mdiInformationOutline"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                {
                                                  attrs: { value: "comments" }
                                                },
                                                [
                                                  _vm.activeTab === "comments"
                                                    ? _c("item-comments", {
                                                        attrs: {
                                                          "item-info": _vm.lead
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab",
                                                {
                                                  class: _vm.isDark
                                                    ? "white--text"
                                                    : "primary--text",
                                                  attrs: { href: "#logs" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Logs\n                                            "
                                                  ),
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "$mdiFormatListBulleted"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "logs" } },
                                                [
                                                  _vm.activeTab === "logs"
                                                    ? _c("item-logs", {
                                                        attrs: {
                                                          "item-info": _vm.lead
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              typeof _vm.lead.policy !==
                                                "undefined" &&
                                              _vm.lead.policy !== null
                                                ? _c(
                                                    "v-tab",
                                                    {
                                                      class: _vm.isDark
                                                        ? "white--text"
                                                        : "primary--text",
                                                      attrs: { href: "#policy" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Policy\n                                            "
                                                      ),
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "$mdiClipboardTextOutline"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "policy" } },
                                                [
                                                  _vm.activeTab === "policy"
                                                    ? _c("item-policy", {
                                                        attrs: {
                                                          "item-info": _vm.lead
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              typeof _vm.lead.last_quote !==
                                                "undefined" &&
                                              _vm.lead.last_quote !== null
                                                ? _c(
                                                    "v-tab",
                                                    {
                                                      class: _vm.isDark
                                                        ? "white--text"
                                                        : "primary--text",
                                                      attrs: {
                                                        href: "#quotations"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Quotations\n                                            "
                                                      ),
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "$mdiFileDocumentOutline"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                {
                                                  attrs: { value: "quotations" }
                                                },
                                                [
                                                  _vm.activeTab === "quotations"
                                                    ? _c("item-quotations", {
                                                        attrs: {
                                                          "item-info": _vm.lead
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "", column: "" } },
            [
              _c("v-progress-circular", {
                attrs: { size: 50, color: "secondary", indeterminate: "" }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }